import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as coordinatorService from '@/services/coordinatorService';
import { useAuth } from '@/contexts/AuthContext';

export const useCoordinatorProcurements = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['coordinator-procurements', user?.id],
    queryFn: () => coordinatorService.getCoordinatorProcurements(user?.id!),
    enabled: !!user?.id
  });
};

export const useCoordinatorProcurementStats = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['coordinator-procurement-stats', user?.id],
    queryFn: () => coordinatorService.getCoordinatorProcurementStats(user?.id!),
    enabled: !!user?.id
  });
};

export const useCoordinatorFarmerRegistrations = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['coordinator-farmer-registrations', user?.id],
    queryFn: () => coordinatorService.getCoordinatorFarmerRegistrations(user?.id!),
    enabled: !!user?.id
  });
};

export const useCreateFarmerRegistration = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  
  return useMutation({
    mutationFn: ({ farmerId, notes }: { farmerId: string; notes?: string }) => 
      coordinatorService.createFarmerRegistration(user?.id!, farmerId, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['coordinator-farmer-registrations'] });
      queryClient.invalidateQueries({ queryKey: ['coordinator-stats'] });
    }
  });
};